import { BOARD_CONFIG, IS_MIX_CATALOG } from "@/config/browserBoard";

export type CurrentBoardThreadRoute =
  | Readonly<{
      to: "/thread/$threadId";
      params: Readonly<{ threadId: string }>;
    }>
  | Readonly<{
      to: "/$slug/thread/$threadId";
      params: Readonly<{ slug: string; threadId: string }>;
    }>;

/**
 * 現在の板スコープ(mixではアンカー板、板mountではその板)のスレページへの
 * router遷移先を決める。mix配下では常にアンカー板slug付きURL
 * (`/mix/{slug}/thread/{id}`)を生成し、`/mix/thread/{id}` のslug無し形の
 * 混入を防ぐ。板mountではTanStack Routerのbasepath `/b/{slug}` が付与
 * されるため、従来の `/thread/$threadId` をそのまま用いる
 * (`/$slug/thread/$threadId` を渡すと板basepathの後にslugが二重に付く)。
 */
export function resolveCurrentBoardThreadRoute(
  threadId: string,
  isMixCatalog: boolean = IS_MIX_CATALOG,
  boardKey: string = BOARD_CONFIG.boardKey,
): CurrentBoardThreadRoute {
  if (isMixCatalog) {
    return {
      to: "/$slug/thread/$threadId",
      params: { slug: boardKey, threadId },
    };
  }
  return {
    to: "/thread/$threadId",
    params: { threadId },
  };
}
